module.exports = __webpack_public_path__ + "static/media/hat-greece.86ba3409.png";